import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "report-grouping",
    templateUrl: "./report-grouping.html",
    styleUrls: ["./report-grouping.scss"],
    imports: [FormsModule, TranslatePipe]
})
export class ReportGroupingComponent implements OnChanges {
    @Input() groupings: string[];
    @Input() currentGrouping: string;
    @Output() changedGrouping = new EventEmitter();

    ngOnChanges() {
        if (this.groupings && this.groupings.indexOf(this.currentGrouping) < 0 && this.groupings.length > 0) {
            this.currentGrouping = this.groupings[0];
        }
    }
}